var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Screen',{class:_vm.$store.state.theaterMode ? 'active' : 'disabled',style:('z-index: ' + _vm.$store.state.theaterScreenDepth),on:{"click":function($event){return _vm.$store.dispatch('theaterScreenClicked')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }